import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { State } from './type';
import { mainPageId } from './helper';
import { useWindowSize, scrollTo, useTimelineQuery } from './fake';
import TimelineView from './product-timeline/timeline';
import ErrorView from './product-timeline/error';
import SkeletonView from './product-timeline/skeleton';
import styles from './product-timeline.module.scss';
import { Order } from './interfaces/myOrder';
import { Product } from './interfaces/orderSaleProduct';

const View: React.FC<{
  state: State;
  updateState: (s: State) => void;
}> = ({ state, updateState }) => {
  const { currentProduct, currentOrder } = state;

  if (currentProduct === null) {
    return <>Missing product</>;
  }

  return (
    <Detail
      state={state}
      updateState={updateState}
      currentProduct={currentProduct}
      currentOrder={currentOrder}
    />
  );
};

const Detail: React.FC<{
  state: State;
  updateState: (s: State) => void;
  currentProduct: Product;
  currentOrder: Order | null;
}> = ({ state, updateState, currentOrder, currentProduct }) => {
  const { t } = useTranslation();
  const { isWiderThanMd } = useWindowSize();
  const { isErrorTimeline, timeline } = useTimelineQuery(
    Number(currentProduct.productId),
    currentOrder ? Number(currentOrder.orderId) : null,
  );

  useEffect(() => {
    scrollTo(`#${mainPageId}`);
  }, [currentProduct.productId]);

  const childView = timeline ? (
    <TimelineView
      order={currentOrder}
      product={currentProduct}
      timeline={{
        ...timeline,
        sellerShippingAddress: state.sellerShippingAddress,
        kind: state.currentTab === 'Sale' ? 'Seller' : 'Buyer',
        seller: state.seller,
      }}
    />
  ) : isErrorTimeline ? (
    <ErrorView
      state={state}
      updateState={updateState}
    />
  ) : (
    <SkeletonView loading={true} />
  );

  return (
    <div className={styles.ordersSales__mainRight}>
      {!isWiderThanMd && (
        <div className={styles.ordersSales__mainRight__back}>
          <button
            onClick={() => updateState({ ...state, currentProduct: null, currentOrder: null })}
            className={styles.ordersSales__mainRight__back__btn}
          >
            <svg
              fill="none"
              viewBox="0 0 9 16"
              className={styles.ordersSales__mainRight__back__icon}
            >
              <path
                d="M8.125 1.12616L1.25 8.00116L8.125 14.8762"
                stroke="#1A1A1A"
              />
            </svg>
            {t('MY_ACCOUNT.ORDERS_SALES.BACK')}
          </button>
        </div>
      )}
      {childView}
    </div>
  );
};

export default View;
